import type { SalaryAdvanceRepaymentItem } from "@/modules/hr/salary-advance/domain/contracts/types";

const LAO_MONTHS = [
  "",
  "ມັງກອນ",
  "ກຸມພາ",
  "ມີນາ",
  "ເມສາ",
  "ພຶດສະພາ",
  "ມິຖຸນາ",
  "ກໍລະກົດ",
  "ສິງຫາ",
  "ກັນຍາ",
  "ຕຸລາ",
  "ພະຈິກ",
  "ທັນວາ",
];

function formatLAK(amount: number) {
  return `${new Intl.NumberFormat("lo-LA").format(amount)} ກີບ`;
}

type Props = { repayments: SalaryAdvanceRepaymentItem[] };

export function RepaymentScheduleTable({ repayments }: Props) {
  if (repayments.length === 0) {
    return <p className="text-muted-foreground text-sm">ຍັງບໍ່ມີຕາຕະລາງຫັກຄືນ</p>;
  }

  return (
    <div className="overflow-x-auto rounded-lg border">
      <table className="w-full text-sm">
        <thead className="border-b bg-muted/40">
          <tr>
            <th className="px-4 py-2 text-left font-medium text-muted-foreground">
              ງວດ
            </th>
            <th className="px-4 py-2 text-right font-medium text-muted-foreground">
              ຈຳນວນ
            </th>
            <th className="px-4 py-2 text-left font-medium text-muted-foreground">
              ສະຖານະ
            </th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {repayments.map((r) => (
            <tr key={r.id} className="hover:bg-muted/20">
              <td className="px-4 py-2">
                {LAO_MONTHS[r.periodMonth]} {r.periodYear}
              </td>
              <td className="px-4 py-2 text-right tabular-nums">
                {formatLAK(r.amount)}
              </td>
              <td className="px-4 py-2">
                {r.status === "deducted" ? (
                  <span className="inline-flex items-center rounded-full border border-green-200 bg-green-100 px-2 py-0.5 font-medium text-green-800 text-xs">
                    ຫັກແລ້ວ
                  </span>
                ) : (
                  <span className="inline-flex items-center rounded-full border border-yellow-200 bg-yellow-100 px-2 py-0.5 font-medium text-xs text-yellow-800">
                    ລໍຖ້າຫັກ
                  </span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="border-t bg-muted/20">
          <tr>
            <td className="px-4 py-2 font-medium">ລວມ</td>
            <td className="px-4 py-2 text-right font-semibold tabular-nums">
              {formatLAK(repayments.reduce((s, r) => s + r.amount, 0))}
            </td>
            <td />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
